var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
// Can Support Shared Workers Interface
OCS.Interfaces.CSSharedWorkers = {
    shared_worker_support: true,
    queued_shared_workers: [],
    shared_workers: {},
    init_shared_workers: function () {
        this.bound_methods.on_shared_worker_terminated = this.on_shared_worker_terminated.bind(this);
        this.bound_methods.on_shared_worker_online = this.on_shared_worker_online.bind(this);
        this.bound_methods.on_shared_worker_status_update = this.on_shared_worker_status_update.bind(this);
    },    
    create_shared_worker: function (request_info) {
        if (!request_info.path || this.is_active_full()) {
            return false;
        }
        var path = request_info.path;
        if (Object.keys(this.shared_workers).contains(path)) {
            return false;
        }
        /* istanbul ignore if */
        if (this.options.debug) {
            console.debug('Worker Manager: Creating a new worker. ', path);
        }
        var worker = new OCS.Classes.SharedWorkerHandler({'path': path});
        worker.addEvent(worker.options.events.worker_online, this.bound_methods.on_shared_worker_online);
        worker.addEvent(worker.options.events.worker_status_update, this.bound_methods.on_shared_worker_status_update);
        worker.addEvent(worker.options.events.worker_terminated, this.bound_methods.on_shared_worker_terminated);
        if (request_info.msg || request_info.init_msg || request_info.msg_queue) {
            worker.set_active_request(request_info);
        }
        this.shared_workers[path] = worker;
        return worker;
    },
    register_shared_worker: function (request_info) {
        if (request_info === null || typeof request_info !== "object" || !Object.keys(request_info).length) {
            return false;
        }
        if (!request_info.path) {
            return false;
        }
        var path = request_info.path;
        if (this.is_active_full() || this.is_type_full(path)) {
            this.queued_shared_workers.push(request_info);
        } else {
            return this.create_shared_worker(request_info);
        }
        return false;
    },
    on_shared_worker_online: function (worker) {
        if (worker && worker.options.path) {
            worker.removeEvent(worker.options.events.worker_online, this.bound_methods.on_worker_online); // Remove this event so that we do not get this firing repeatedly
        }
    },    
    on_shared_worker_status_update: function (worker) {},    
    on_shared_worker_terminated: function (worker) {
        delete this.shared_workers[worker.options.path];
        if (this.queued_shared_workers.length) {
            this.register_shared_worker(this.queued_shared_workers.shift());
        }
    },    
};